/**
 * note_cell_links — derived attribution of a note to a specific financial-statement
 * location. A single note can fan out to many cells (one row per note→cell), each
 * carrying the span that triggered it. The note keeps its own authored anchor
 * (cell_notes); these links are additive and never mutate the original note.
 */

/** Where a link came from. Parsed is suggested; amendment/rule are established facts. */
export enum NoteCellLinkSource {
  Parsed = 'parsed',
  Amendment = 'amendment',
  Rule = 'rule',
}

/** How a parsed match was made — drives the confidence display (3/2/1 bars). */
export enum NoteCellLinkConfidenceBasis {
  Exact = 'exact',
  Synonym = 'synonym',
  Inferred = 'inferred',
}

/**
 * The confidence bases eligible to skip human review, once the measured confirm rate earns
 * it. Only exact line-item matches qualify: a synonym hit is a colloquialism resolving to a
 * canonical row, and an inferred hit is a model judgement — both are the "uncertain" half the
 * task routes to review. Gated at runtime by config.noteAttribution.autoConfirm, which stays
 * off until ListAttributionAccuracy shows the band deserves it.
 */
export const AUTO_CONFIRM_CONFIDENCE_BASES: NoteCellLinkConfidenceBasis[] = [
  NoteCellLinkConfidenceBasis.Exact,
]

/** Lifecycle of a link. Established facts (amendment/rule) are created already Confirmed. */
export enum NoteCellLinkStatus {
  Suggested = 'suggested',
  Confirmed = 'confirmed',
  Dismissed = 'dismissed',
}

/** Character span(s) in the note text that produced the link (for highlighting). */
export interface INoteCellLinkOffsets {
  start: number
  end: number
}
